import {
  formatMoney,
  formatMoneyByType,
  formatWithCommasAndDecimals,
  formatWithLeadingPlusOrMinus,
} from "~utils/portfolio/formatNumber";

const NUMBER_ABBREVIATION_THRESHOLDS = [
  {
    abbreviation: {
      en: "T",
      ja: "兆",
    },
    threshold: 1e12,
  },
  {
    abbreviation: {
      en: "B",
      ja: "十億",
    },
    threshold: 1e9,
  },
  {
    abbreviation: {
      en: "M",
      ja: "百万",
    },
    threshold: 1e6,
  },
  {
    abbreviation: {
      en: "K",
      ja: "千",
    },
    threshold: 1e3,
  },
];

export function isTickerUp(price: number, type = "") {
  const priceIsUp = price >= 0;

  if (type === "GOV") {
    return !priceIsUp;
  }

  return priceIsUp;
}

export function formatPriceChangeWithCurrency(
  priceChange: number,
  currency: string,
  type = ""
) {
  const formattedPrice = formatMoneyByType(priceChange, type);

  return formatWithLeadingPlusOrMinus(formattedPrice, currency);
}

export function formatPriceChange(priceChange: number, type = "") {
  const formattedPrice = formatMoneyByType(priceChange, type);

  return formatWithLeadingPlusOrMinus(formattedPrice);
}

export function formatPercentChange(percentChange: number) {
  const formattedPercentage = formatWithCommasAndDecimals(percentChange);

  return `${formatWithLeadingPlusOrMinus(formattedPercentage)}%`;
}

export function formatBigNumberWithCurrency(
  number: number,
  currency: string,
  decimals: number,
  trimDecimalZeros = false
) {
  return `${currency}${formatBigNumber(number, decimals, trimDecimalZeros)}`;
}

export function formatBigNumber(
  number: number,
  decimals: number,
  trimDecimalZeros = false,
  locale: "en" | "ja" = "en"
) {
  if (typeof number !== "number") {
    return number;
  }

  for (let i = 0; i < NUMBER_ABBREVIATION_THRESHOLDS.length; i++) {
    const { abbreviation, threshold } = NUMBER_ABBREVIATION_THRESHOLDS[i];
    const localeAbbreviation = abbreviation[locale] || abbreviation.en;

    if (Math.abs(number) >= threshold) {
      const value = formatMoney(number / threshold, decimals, trimDecimalZeros);

      return `${value} ${localeAbbreviation}`;
    }
  }

  return formatMoney(number, decimals, trimDecimalZeros);
}

export function formatBigNumberByType(
  number: number,
  type: string,
  trimDecimalZeros = false,
  locale: "en" | "ja" = "en"
) {
  if (typeof number !== "number") {
    return number;
  }

  for (let i = 0; i < NUMBER_ABBREVIATION_THRESHOLDS.length; i++) {
    const { abbreviation, threshold } = NUMBER_ABBREVIATION_THRESHOLDS[i];
    const localeAbbreviation = abbreviation[locale] || abbreviation.en;

    if (Math.abs(number) >= threshold) {
      const value = formatMoneyByType(
        number / threshold,
        type,
        trimDecimalZeros
      );

      return `${value} ${localeAbbreviation}`;
    }
  }

  return formatMoneyByType(number, type, trimDecimalZeros);
}
